var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation-options_item",on:{"click":function($event){return _vm.$emit('click')}}},[_c(("icon-" + _vm.option),{tag:"component",staticClass:"text-icon transition duration-200",class:_vm.active && 'text-icon-hover'})],1)}
var staticRenderFns = []

export { render, staticRenderFns }